import MentoringMain from './MentoringMain.vue';

export * from './components';
export * from './types';
export default MentoringMain;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/programcard/components/main/index.ts